import api from './index';

const UserApi = {
    getPayments: (id, params) => api.get(`/user/${id}/payments`, params),
    getNotifications: (id, params) => api.get(`/user/${id}/notifications`, params),
    getUserInfo: (id, params) => api.get(`/user/${id}`, params),
    getUserStats: (id, params) => api.get(`user/${id}/statistics`, params),
    activateAccount: (id, body) => api.post(`user/${id}/activate`, body),
    changePassword: (id, body) => api.post(`user/${id}/password/update`, body),
    updateInfo: (id, body) => api.post(`user/${id}/update`, body)
};

export default UserApi;
